import { FC, useContext, useMemo } from "react";
import {
  QuizContext,
  TextConfig,
} from "../../providers/QuizProvider/QuizContext";
import { getStyleFromTextConfig } from "../../utils/style";
import { AnswerDataInfo, AnswersBox } from "../Answers/AnswersBox";
import { ArticleContent } from "../ArticleContent/ArticleContent";
import { Bonuses } from "../Bonuses/Bonuses";
import { Button } from "../Button/Button";
import { Desktop } from "../Container/Desktop";
import { Mobile } from "../Container/Mobile";
import { Discount } from "../Discount/Discount";
import { DiscountProgress } from "../DiscountProgress/DiscountProgress";
import { LayoutQuestionPage } from "../LayoutQuestionPage/LayoutQuestionPage";
import { Progress } from "../Progress/Progress";
import {
  Title,
  Wraper,
  BoxBonuse,
  Footer,
  ContentBox,
  Text,
  BoxContainer,
} from "./QuestionPage.styled";
import { getProgressDiscount } from "../../utils/progressDiscount";
import { useTranslation } from "../../hooks/useTranslation";
import { Scrollbars } from 'rc-scrollbars';
import { TextLabel } from '../TextLabel/TextLabel'

export const initValue = {
  skip: true,
  answer: null,
  options_answer: [],
} as AnswerDataInfo;

export type PropsForPreview = {
  id?: number;
  title: string;
  title_config?: TextConfig;
  description?: string;
  description_config?: TextConfig;
  type?: number;
  config?: any;
  answers: unknown[];
  //   everyone?: boolean;
  progressValue: number;
  progressCount: number;

  additions: any[];
  required: boolean;

  onNext?: (answer: unknown) => void;
  onPrev?: () => void;
  isEditing?: boolean;
};

type Props = PropsForPreview & {
  answer: AnswerDataInfo;
  setAnswer: (answer: AnswerDataInfo) => void;
};

export const QuestionPage: FC<Props> = ({
  id,
  title,
  title_config,
  description,
  description_config,
  type,
  config,
  answers,
  progressValue,
  progressCount,
  additions,
  required,
  onPrev,
  answer,
  setAnswer,
  isEditing,
  ...props
}) => {
  const { t } = useTranslation();

  const context = useContext(QuizContext);
  const { design_type, progress_bar_style, addition_page_display, currency } =
    context;
  const addition_position_display = context.addition_position_display ?? 1;

  const additionsWithoutConsultant = useMemo(
    () => additions.filter(({ type }) => type !== 3),
    [additions]
  );

  const firstProgress = additions.find(
    ({ config }) => config?.typeDiscount === 2
  );

  const discountProgressValue = firstProgress
    ? getProgressDiscount(
      firstProgress.config?.discountValue,
      progressValue,
      progressCount,
      firstProgress.config?.unitDiscount,
      currency?.title
    )
    : "";

  const isDisabled = required && answer.skip;

  const onNext = () => {
    if(isDisabled) return;
    props.onNext && props.onNext(answer);
  };

  return (
    <LayoutQuestionPage design_type={design_type}>
      {(addition_page_display === 1 || addition_page_display === 3) &&
        addition_position_display === 1 && (
          <ArticleContent
            additions={additions}
            addition_position_display={addition_position_display}
            discountProgressValue={discountProgressValue}
            lockBonus={true}
          />
        )}
      {(addition_page_display === 1 || addition_page_display === 3) &&
        addition_position_display === 2 && (
          <Mobile>
            <ArticleContent
              additions={additions}
              addition_position_display={addition_position_display}
              discountProgressValue={discountProgressValue}
              lockBonus={true}
            />
          </Mobile>
        )}

      <Wraper addition_position_display={addition_position_display}  >
        <ContentBox>
          <Title style={getStyleFromTextConfig(title_config)}>{title}</Title>
          <Text style={getStyleFromTextConfig(description_config)}>
            {description}
          </Text>
            <Scrollbars>
              <AnswersBox
                value={answer}
                onChange={setAnswer}
                answers={answers}
                questionConfig={config}
                questionType={type ?? 1}
                isEditing={isEditing}
              />
            </Scrollbars>
        </ContentBox>

        <Footer addition_position_display={addition_position_display}>
          <Mobile>
            <>
              <Progress
                progressType={progress_bar_style ? 1 : null}
                count={progressCount}
                value={progressValue}
              />
              <BoxContainer>
                <BoxBonuse>
                  {(addition_page_display === 1 ||
                    addition_page_display === 3) &&
                    additionsWithoutConsultant.map((item) =>
                      item.type === 2 ? (
                        <Discount
                          key={item.id}
                          addition={item}
                          style={{ marginRight: "5px" }}
                          lockBonus={true}
                          disabledDecor={true}
                        />
                      ) : (
                        <Bonuses
                          key={item.id}
                          addition={item}
                          style={{ marginRight: "5px" }}
                          lockBonus={true}
                          disabledDecor={true}
                        />
                      )
                    )}
                  {additionsWithoutConsultant.length < 2 && firstProgress && (
                    <DiscountProgress
                      style={{
                        // width: "80px",
                        marginRight: "5px",
                        paddingInline: "12px",
                      }}
                      text={t("yourDiscount")}
                      value={discountProgressValue}
                    />
                  )}
                </BoxBonuse>

                <Button
                  //type={button_style}
                  isHideArrow={false}
                  isShowBack={true}
                  onNext={onNext}
                  onPrev={onPrev}
                  isDisabled={isDisabled}
                />
              </BoxContainer>
              <TextLabel style={{position: 'absolute', left: "20px", bottom: "3px"}} />
            </>
          </Mobile>
          <Desktop>
            <>
              <Progress
                progressType={progress_bar_style ?? null}
                count={progressCount}
                value={progressValue}
              />

              <Button
                //type={button_style}
                isHideArrow={false}
                isShowBack={true}
                onNext={onNext}
                onPrev={onPrev}
                isDisabled={isDisabled}
              />
            </>
          </Desktop>
          
        </Footer>
      </Wraper>

      {
        (addition_page_display === 1 || addition_page_display === 3) &&
        addition_position_display === 2 && (
          <Desktop>
            <ArticleContent
              additions={additions}
              addition_position_display={addition_position_display}
              discountProgressValue={discountProgressValue}
              lockBonus={true}
            />
          </Desktop>
        )
      }
    </LayoutQuestionPage >
  );
};
